enum localStorageReferences {
    PINNED_COMMENT_MENU = 'storedPinnedCommentMenu',
    HIGHLIGHTED_COMMENTS_TO_REMOVE = 'storedHighlightedCommentsToRemove',
    SELECTED_DATE = 'storedSelectedDate',
}

export { localStorageReferences };
